import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "badge-value" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "status-circle"
}

import {computed} from 'vue';
import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import {internationalUrlIfNeeded} from "~/core-ui/ts/Constants";
import OperatorApplicationPlatformIcon from "~/operatorApplication/vue/misc/OperatorApplicationPlatformIcon.vue";


const __default__ = {
    name: "CoreUiAvatar"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    background: {},
    src: {},
    name: {},
    size: { default: "30px" },
    statusColor: {},
    statusColorClass: {},
    statusIcon: {},
    icon: {},
    overrideHost: {},
    badgeTooltip: {},
    platform: {},
    showStatus: { type: Boolean, default: true }
  },
  setup(__props: any) {

let props = __props;

let letters = computed(() => {
    if (props.name) {
        let name = props.name;
        name = name.toUpperCase().replace(/[^A-ZА-ЯЁ]/g, " ");
        let words = name.split(/\s/);
        let result = [];
        for (let i = 0; i < words.length && result.length < 2; i++) {
            if (words[i].length > 0) {
                result.push(words[i][0]);
            }
        }
        if (result.length) {
            return result.join("");
        }
    }
    return null;
});

let isStatusDisplayed = computed(() => props.showStatus && (props.statusColor || props.statusColorClass));

let preparedSrc = computed(() => {
    return props.src ? internationalUrlIfNeeded(props.src) : null;
});


return (_ctx: any,_cache: any) => {
  const _directive_my_tooltip = _resolveDirective("my-tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: "core-ui-avatar",
    style: _normalizeStyle({
            /*background: background ? background : '#bdc3c7',*/
            width: __props.size,
            height: __props.size,
            minWidth: __props.size
        })
  }, [
    (_unref(letters) || __props.icon || __props.platform)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: _normalizeClass({letters: true, mask: _unref(isStatusDisplayed)}),
          style: _normalizeStyle({
                 fontSize: __props.size,
                 background: __props.background ? __props.background : '#bdc3c7'
             })
        }, [
          _createElementVNode("span", null, [
            (__props.platform)
              ? (_openBlock(), _createBlock(OperatorApplicationPlatformIcon, {
                  key: 0,
                  platform: __props.platform,
                  "with-color": false,
                  class: "m-0"
                }, null, 8, ["platform"]))
              : (__props.icon)
                ? (_openBlock(), _createBlock(FontAwesomeIcon, {
                    key: 1,
                    icon: __props.icon,
                    class: "m-0"
                  }, null, 8, ["icon"]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createTextVNode(_toDisplayString(_unref(letters)), 1)
                  ], 64))
          ])
        ], 6))
      : (_unref(preparedSrc))
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass({img: true, mask: _unref(isStatusDisplayed)}),
            style: _normalizeStyle({
                backgroundImage: `url('${_unref(preparedSrc)}')`,
                backgroundColor: __props.background ? __props.background : '#bdc3c7',
                fontSize: __props.size
            })
          }, null, 6))
        : _renderSlot(_ctx.$slots, "default", { key: 2 }),
    (_ctx.$slots.badge)
      ? (_openBlock(), _createElementBlock("span", {
          key: 3,
          class: "badge status",
          onMouseover: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
          onMouseenter: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
        }, [
          _withDirectives((_openBlock(), _createElementBlock("span", null, [
            _createElementVNode("span", _hoisted_1, [
              _renderSlot(_ctx.$slots, "badge")
            ])
          ])), [
            [_directive_my_tooltip, __props.badgeTooltip]
          ])
        ], 32))
      : _createCommentVNode("", true),
    (_unref(isStatusDisplayed))
      ? (_openBlock(), _createElementBlock("span", {
          key: 4,
          class: _normalizeClass({
                status: true,
                'custom-icon': !!__props.statusIcon,
                [`text-${__props.statusColorClass}`]: !!__props.statusColorClass
            }),
          style: _normalizeStyle({
                color: __props.statusColor ? `${__props.statusColor} !important` : null,
                fontSize: __props.size
            })
        }, [
          _createElementVNode("span", null, [
            (__props.statusIcon)
              ? (_openBlock(), _createElementBlock("i", _hoisted_2))
              : (_openBlock(), _createElementBlock("span", _hoisted_3))
          ])
        ], 6))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "append")
  ], 4))
}
}

})